var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__title_head"},[_c('article-title-head',{attrs:{"options":{
                    category: _vm.currentPage.content.oTitleHead_sCategory.text,
                    phrase: _vm.currentPage.content.oTitleHead_sPhrase.text,
                    author: _vm.currentPage.content.oTitleHead_sAuthor.text,
                    from: _vm.currentPage.content.oTitleHead_nFrom.text,
                    to: _vm.currentPage.content.oTitleHead_nTo.text,
                    color: 'text-sushi',
                }}})],1),_c('div',{staticClass:"q10__article_container__content"},[_c('div',{staticClass:"\n                    q10__article_container__content__vertical_head\n                    mx-auto\n                    relative\n                "},[_c('div',{staticClass:"relative"},[_c('article-vertical-head',{attrs:{"options":{
                            text: _vm.currentPage.content.oVerticalHead_sText
                                .text,
                            position: 'lg:ml-2',
                            imageAuthor:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image_001.src,
                        }}}),_c('hotspot-richmedia',{staticClass:"top-6 right-1 lg:right-6",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Interview de Y. Baros'
                            ),
                        }}})],1)]),_c('div',{staticClass:"q10__article_container__content__paragraphs"},[_c('paragraph-first-letter-big',{attrs:{"options":{
                        letter: _vm.currentPage.content.firstParagraph.text.substr(
                            0,
                            1
                        ),
                        color: 'text-sushi',
                    }}}),_c('paragraph',{attrs:{"options":{}}},[_c('span',{domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.firstParagraph.text.slice(1)
                        )}})])],1)])]),_c('timeline-carousel',{attrs:{"options":{
            timeline: _vm.currentPage.timeline,
        }}}),_c('div',{staticClass:"container px-11 2xl:px-3  m-auto"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"bottom-2 left-2.5 lg:left-1.5",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'La STEP d’Hatta concrétise les ambitions de Dubaï'
                        ),
                    }}}),_c('image-with-descriptions',{attrs:{"options":{
                    image:
                        'pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.image_002.src,
                    descriptions: [
                        {
                            text: _vm.currentPage.images.image_002.text,
                            position: 'top-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: _vm.currentPage.images.image_002.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        } ],
                }}})],1),_c('div',{staticClass:"relative  flex flex-col lg:flex-row w-full"},[_c('article-note',{staticClass:"md:w-full",attrs:{"options":{
                verticalcontent: _vm.currentPage.content.verticalContent.text,
                title: _vm.currentPage.content.sTitle.text,
                content: _vm.currentPage.content.secondParagraph.text,
                color: {
                    verticalcontent: 'text-cornflower_blue',
                    title: 'text-selective_green',
                    content: 'text-nandor',
                },
                fontSize: {
                    verticalcontent: 'text-4xl md:text-3xl lg:text-4xl',
                    title: 'text-4xl md:text-3xl lg:text-4xl',
                    content: 'text-md md:text-xl lg:text-xl',
                },
                margin: {
                    verticalcontent: 'mt-1',
                },
            }}}),_c('div',{staticClass:"customFixWidth relative my-auto pl-5"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection: _vm.getRichmediaByCollection(
                        _vm.currentPage,
                        'Retour sur le Suntrip 2019'
                    ),
                }}}),_c('image-with-descriptions',{attrs:{"options":{
                    image:
                        'pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.image_003.src,
                    descriptions: [
                        {
                            text: _vm.currentPage.images.image_003.text,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                            fontSize: 'text-xs md:text-base',
                        } ],
                }}})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }